export const GET_WIND_TURBINES_CAPACITY_FACTOR = "GET_WIND_TURBINES_CAPACITY_FACTOR";
export const GET_WIND_TURBINES_CAPACITY_FACTOR_SUCCESS = "GET_WIND_TURBINES_CAPACITY_FACTOR_SUCCESS";
export const GET_WIND_TURBINES_CAPACITY_FACTOR_ERROR = "GET_WIND_TURBINES_CAPACITY_FACTOR_ERROR";
